import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const SearchIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14.5986 14.5986C16.4626 12.7346 16.4626 9.71263 14.5986 7.8487C12.7347 5.98478 9.7127 5.98478 7.84877 7.8487C5.98485 9.71263 5.98485 12.7346 7.84877 14.5986C9.7127 16.4625 12.7347 16.4625 14.5986 14.5986ZM14.5986 14.5986L17.2504 17.2503"
        stroke={fillColor || '#111112'}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export { SearchIcon };
